import { render, staticRenderFns } from "./StarterTypeManagerForm.vue?vue&type=template&id=33b78bec&"
import script from "./StarterTypeManagerForm.vue?vue&type=script&lang=ts&"
export * from "./StarterTypeManagerForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports